import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-shalini',
  templateUrl: './shalini.component.html',
  styleUrls: ['./shalini.component.scss']
})
export class ShaliniComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getShalini();
  }

}
